import { Routes, Route } from 'react-router-dom';
import { MainWrapper, ThemeWrapper } from '@flixbus/honeycomb-react';

import { AuthenticatedTemplate, MsalProvider, UnauthenticatedTemplate } from '@azure/msal-react';
import { IPublicClientApplication } from '@azure/msal-browser';

import './App.scss';
import '@flixbus/honeycomb-react/dist/css/honeycomb-helpers.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { Footer, Header } from './components';
import { NotificationProvider } from './components/Notifications/Context';
import { RolesProvider } from './context/RolesProvider';

import { Profile } from './pages/Profile';
import { Dashboard } from './pages';
import { VoucherDetail } from './pages/VoucherDetail';
import { BatchStatus } from './pages/BatchStatus';
import { SuccessPage } from './pages/Success';
import { BatchesDashboard } from './pages/BatchesDashboard';

import { withRoleProtection } from './components/Auth';

import AddVoucherTemplates from './routes/AddVoucherTemplates';

import { ROLES } from './types/Roles';
import SignInCard from './components/SignInCard/SignInCard';
import { UploadCSV } from './pages/UploadCSV';
import { UploadCSVSuccess } from './pages/UploadCSVSuccess';

const ProtectedProfile = withRoleProtection(Profile, {
  requiredRoles: [],
});

const ProtectedVoucherDetail = withRoleProtection(VoucherDetail, {
  requiredRoles: [ROLES.ROLE_VIEW_VOUCHER_DETAIL],
});

const ProtectedUploadCSV = withRoleProtection(UploadCSV, {
  requiredRoles: [ROLES.ROLE_UPDATE_MULTIPLE_VOUCHERS],
});

const ProtectedBatchesDashboard = withRoleProtection(BatchesDashboard, {
  requiredRoles: [ROLES.ROLE_VOUCHER_BATCH_USER],
});

type AppProps = {
  pca: IPublicClientApplication;
};

function App({ pca }: AppProps) {
  return (
    <MsalProvider instance={pca}>
      <ThemeWrapper>
        <NotificationProvider>
          <MainWrapper full extraClasses='main-wrapper'>
            <Header />
            <div id='global-notifications' />
            <main className='main-container'>
              <AuthenticatedTemplate>
                <RolesProvider>
                  <Routes>
                    <Route path='/' element={<Dashboard />} />
                    <Route path='/profile' element={<ProtectedProfile />} />
                    <Route path='/voucher/:id' element={<ProtectedVoucherDetail />} />
                    <Route path='/upload-csv' element={<ProtectedUploadCSV />} />
                    <Route path='/upload-csv-success/:id' element={<UploadCSVSuccess />} />
                    <Route path='success/:id' element={<SuccessPage />} />
                    <Route path='batch/:id' element={<BatchStatus />} />
                    <Route path='/my-voucher-batches' element={<ProtectedBatchesDashboard />} />
                    {AddVoucherTemplates.map(e => (
                      <Route key={e.name} {...e} />
                    ))}
                  </Routes>
                </RolesProvider>
              </AuthenticatedTemplate>
              <UnauthenticatedTemplate>
                <SignInCard />
              </UnauthenticatedTemplate>
            </main>
            <Footer />
          </MainWrapper>
        </NotificationProvider>
      </ThemeWrapper>
    </MsalProvider>
  );
}

export default App;
